import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { CancelIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React from 'react';
import useActiveElement from '../hooks/useActiveElement.js';
import FocusTrap from '../utils/FocusTrap.js';
import Button from './Button.js';
import Divider from './Divider.js';
import Grid from './Grid.js';
import Heading from './Heading.js';
import Overlay from './Overlay.js';

var _excluded = ["as", "className", "onRequestClose", "headingText"],
  _excluded2 = ["children", "className", "headingText", "isVisible", "lg", "location", "md", "onRequestClose", "sm", "spacing", "xl", "xs"];
var DrawerHeader = function DrawerHeader(_ref) {
  _ref.as;
    var className = _ref.className,
    onRequestClose = _ref.onRequestClose,
    headingText = _ref.headingText,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Grid.Container, _extends({}, otherProps, {
    className: className
  }), /*#__PURE__*/React.createElement(Grid.Item, {
    xs: true
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 3,
    className: "hc-fs-lg"
  }, headingText)), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Close",
    "data-test": "drawerCloseButton",
    iconOnly: true,
    type: "ghost",
    size: "dense",
    className: "C-Drawer__closeButton",
    onClick: onRequestClose
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: CancelIcon
  }))));
};
DrawerHeader.displayName = 'Drawer.Header';
var Drawer = function Drawer(_ref2) {
  var _classnames;
  var children = _ref2.children,
    className = _ref2.className,
    headingText = _ref2.headingText,
    isVisible = _ref2.isVisible,
    lg = _ref2.lg,
    _ref2$location = _ref2.location,
    location = _ref2$location === void 0 ? 'right' : _ref2$location,
    md = _ref2.md,
    onRequestClose = _ref2.onRequestClose,
    sm = _ref2.sm,
    _ref2$spacing = _ref2.spacing,
    spacing = _ref2$spacing === void 0 ? 'normal' : _ref2$spacing,
    xl = _ref2.xl,
    xs = _ref2.xs,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  // Cache the current focused dom element across re-renders
  var focusedElRef = useActiveElement(isVisible);
  var handleOnRequestClose = function handleOnRequestClose() {
    onRequestClose();
  };
  var finalClasses = classnames('C-Drawer', (_classnames = {
    '--lg-size-auto': lg === true
  }, _defineProperty(_classnames, "--lg-size-".concat(lg), lg && lg !== true), _defineProperty(_classnames, '--md-size-auto', md === true), _defineProperty(_classnames, "--md-size-".concat(md), md && md !== true), _defineProperty(_classnames, '--sm-size-auto', sm === true), _defineProperty(_classnames, "--sm-size-".concat(sm), sm && sm !== true), _defineProperty(_classnames, '--xl-size-auto', xl === true), _defineProperty(_classnames, "--xl-size-".concat(xl), xl && xl !== true), _defineProperty(_classnames, '--xs-size-auto', xs === true), _defineProperty(_classnames, "--xs-size-".concat(xs), xs && xs !== true), _defineProperty(_classnames, "--location-".concat(location), location), _defineProperty(_classnames, "isVisible", isVisible), _classnames), className);
  var containerClasses = classnames('hc-container', "hc-pa-".concat(spacing !== 'none' ? spacing : 'normal'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FocusTrap, {
    active: isVisible,
    returnFocusTo: focusedElRef.current,
    onEscape: handleOnRequestClose,
    "aria-label": otherProps['aria-label'] || 'Modal'
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: finalClasses
  }, otherProps), headingText && /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(Grid.Item, {
    xs: 12,
    className: "hc-pb-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    onRequestClose: handleOnRequestClose,
    headingText: headingText
  })), /*#__PURE__*/React.createElement(Divider, null))), /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(Grid.Item, {
    xs: 12,
    className: "hc-pb-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: containerClasses
  }, children))))), /*#__PURE__*/React.createElement(Overlay, {
    isVisible: isVisible,
    type: "subtle",
    onClick: handleOnRequestClose
  }));
};
Drawer.displayName = 'Drawer';
Drawer.Header = DrawerHeader;

export { DrawerHeader, Drawer as default };
